import { render, staticRenderFns } from "./aggregatorsRank.vue?vue&type=template&id=76b7dfbf&scoped=true&lang=pug"
import script from "./aggregatorsRank.vue?vue&type=script&lang=js"
export * from "./aggregatorsRank.vue?vue&type=script&lang=js"
import style0 from "./aggregatorsRank.vue?vue&type=style&index=0&id=76b7dfbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7dfbf",
  null
  
)

export default component.exports